import { createContext, useContext } from 'react';

/**
 *  Context
 */

const CollapseContext = createContext(null);

/**
 * useCollapseContext
 */
export const useCollapseContext = () => {
    const context = useContext(CollapseContext);

    if (context == null) {
        throw new Error('Collapse components must be wrapped in <Collapse />');
    }

    return context;
};

export default CollapseContext;
